import tr from "./tr";
import en from "./en";

const DICTS = { tr, en };

export function getRuntimeLang() {
  try {
    const stored = localStorage.getItem("appLanguage");
    return stored === "en" ? "en" : "tr";
  } catch {
    return "tr";
  }
}

export function rt(key, vars, lang = getRuntimeLang()) {
  const dict = DICTS[lang] || DICTS.tr;
  const val = dict[key] ?? DICTS.tr[key] ?? key;
  if (typeof val !== "string") return key;
  if (!vars || typeof vars !== "object") return val;
  return val.replace(/\{\{(\w+)\}\}/g, (_, name) =>
    vars[name] !== undefined ? String(vars[name]) : `{{${name}}}`
  );
}
